import { getData } from '@/utils/http'
import config from '@/config'
export default {
    namespaced: true,
    state: {
      
        tableLoading: true,
        addLoading: false,
        activeItem: null,
        tableList: [],

        //查询条件
        pageIndex: 1,
        total: 0,
        projectId: '',
        orderDate: "",
        orderId: '',
        dispatchId: '',
        status: '',
        year: '',
        month: '',
        day: '',
        code: '',
        deptId: "",
        carNo: "",
        driver: ""
    },
    mutations: {
        CHANGE_TABLE_LOADING(state, tableLoading) {
            state.tableLoading = tableLoading
        },
        CHANGE_ADD_LOADING(state, addLoading) {
            state.addLoading = addLoading
        },
        CHANGE_TABLE_DATA(state, changeData) {
            state.tableList = changeData.data.rows
            state.total = changeData.total
        },
        CHANGE_ACTIVE_ITEM(state, item) {
            const expenseAccountList = [];
            Object.keys(item.expenseAccount).forEach(key => {

                const totalPrice = item.expenseAccount[key].reduce((sum, item) => sum + item.amount, 0);
                const totalAmount = totalPrice.toFixed(2); // "36.02"
                expenseAccountList.push({
                    title: key,
                    tableList: item.expenseAccount[key],
                    totalAmount

                })

            });
            item.expenseAccountList = expenseAccountList;
            state.activeItem = item;
            console.log(state.activeItem);
        },
        CHANGE_SEARCH_COLL(state, changeData) {
            if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
                state[changeData['changeKey']] = [changeData['data']]
            } else {
                state[changeData['changeKey']] = changeData['data']
            }
        },
        CHANGE_TABLE_INDEX(state, value) {
            state.pageIndex = value
        }
    },
    actions: {
        //获取运单列表
        getList({ commit, state }) {


            var day = "";
            var year=state.year;
            var month=state.month;
            if (state.day) {
                day = state.day.split("-")[2];
                //如果选择了日期，并且年和月都是空的，那么需要补全年和月
                year=state.day.split("-")[0];
                month=state.day.split("-")[1];
            }

            return new Promise(resolve => {
                getData(`logistics/waybill/page`, {
                    projectId: state.projectId,
                    orderId: state.orderId,
                    dispatchId: state.dispatchId,
                    status: state.status,
                    page: state.pageIndex,
                    size: config.pageSize,
                    year: year,
                    month:month,
                    carNo: state.carNo,
                    driver: state.driver,
                    day: day,
                    code:state.code
                }).then(res => {
                    if (res.state == 1) {
                        commit('CHANGE_TABLE_DATA', res)
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },

        //获取我的项目列表
        getMyProjectList({ commit, state }, deptId) {
            return new Promise(resolve => {
                getData(`logistics/project/my/list?deptId=${deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功',
                            data: res.data
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg,
                            data: []
                        })
                    }
                })
            })
        },
          
        //写入查询条件
        setSearchData({ commit }, changeData) {
            commit('CHANGE_SEARCH_COLL', changeData)
        },
        //修改分页
        setPageIndex({ commit }, value) {
            commit('CHANGE_TABLE_INDEX', value)
        },
        //修改添加loading
        changeAddLoading({ commit }, value) {
            commit('CHANGE_ADD_LOADING', value)
        },
        //修改添加loading
        changeListLoading({ commit }, value) {
            commit('CHANGE_TABLE_LOADING', value)
        }
    }
}
